import FormBody from './Body';
import FormFooter from './Footer';
import Form from './Form';

export default Form;
export { FormBody, FormFooter };
